module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyWash@3x_4ec14b.png";